module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.31.0.0.box.198.581.1028.421.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.31.0.0.box.198.581.307.34.q.90"
    }
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.31.0.1.box.379.794.847.208.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Where ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Did ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Our ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Founder ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Come ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("From? ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.192.1121.1347.1349.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "2em"
    },
    attrs: {
      "id": "para.31.1.0.box.194.1121.1344.369.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0"
    }
  }), _vm._v("Despite ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Years ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Searching ")]), _vm._v("in Italy, correspondence, and study of nationalization or immigration records, I have not been able to ascertain the exact birthplace of Lorenzo Casso. I am convinced that he never became a naturalized citizen of the United States and that he died as he had lived-- an Italian. Among all sources of information, the naturalization records are the most accessible and the easiest to check, but those records reveal nothing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.195.1502.1343.150.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.1.0"
    }
  }), _vm._v("I shall not go into all the complexities of my search for Lorenzo's birthplace. I shall, however, relate a few pertinent facts that might help us reach some tentative conclusions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.195.1665.1344.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.2.0"
    }
  }), _vm._v("I have gone to some lengths to define the political composition of the Italian peninsula. I am repeating \"Italian peninsula\" to stress the fact that Italy as we know it today did not exist during Lorenzo's residence there. It was not until 1869 that Italy was finally united politically and in the form which we know it to be today. Lorenzo left Italy no later than 1859 and possibly earlier.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.192.1989.1345.481.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.3.0"
    }
  }), _vm._v("In the U.S. Census of 1870, a copy of which appears in this book, he stated that he was from Italy. Now a statement made during this period of history has particular significance, for the Italy he knew when he left at least eleven years earlier was a disunited country; I feel he was referring to the political portion known as Italy. One can presume, therefore, that if he had come from any of the other political divisions he would have said to the census taker that he was from Naples (the Kingdom of Naples), Sardinia (the Kingdom of Sardinia), Tuscany, Parma, or any of the other principalities that made up the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.0.box.194.349.1346.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("\nItalian Peninsula during his time. This is merely presumption, but there seems to be much credence to this theory when one views a map of that period. It is not logical that Lorenzo would say he was from Italy if he were from a specific political entity.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.191.349.1349.2121.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.193.568.1347.637.q.60"
    }
  }, [_vm._v("Another clue is that there is a village of Casso located in the area generally referred to as Italy, both as a kingdom and as a political entity. Actually there is a small township composed of two villages which together have the official name of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Erto ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Casso, ")]), _vm._v("located in what is known as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Venetia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Province. ")]), _vm._v("It is near the Piave River which drains into the Adriatic Sea, and it is also near the city of Belluno, which is the capitol of the province. This area has many designations and has been known by such names as the Udine Province or the Tridentina-Venetia Province. To further add to the confusion, Venetia is translated Venice in English, but this refers to the continental Venice as opposed to the city of Venice which lies on small isles in the Adriatic Sea.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.193.1227.1347.318.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  }), _vm._v("Venetia, or continental Venice, took its name from the ancient inhabitants, the Veneti, who came under Roman rule as early as the second century, B.C. It was also the site of Roman colonization, for Aquileia was the principal city of northeast Italy. From the high peaks of the Julian and Carnic Alps and the sharp summits of the Dolomites, the land slopes towards the Adriatic Sea.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.192.1558.1347.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("The mountains near the village of Casso rise to a height of three thousand feet. In 1963 there were 433 inhabitants in the village and the Italian government positively states that there was no one in the village by the name of Casso. The name, however, is indigenous to this locale, and every Italian scholar contacted stated that although it is a name rarely found in Italy, it is the phonetic type associated with this area.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.4.box.191.1938.1348.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.4.0"
    }
  }), _vm._v("Lest we draw any conclusions from the fact that the village is named Casso, let me also state that these two villages, Erto and Casso, were created by the Italian government as rehabilitation centers. I do not know why these names were chosen, but one may presume that they were meant to either honor two persons associated with the project or to recognize them for services previously rendered to their country.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.5.box.194.2319.1345.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.5.0"
    }
  }), _vm._v("The passport of Lorenzo Casso has never been found which complicated the search for his birthplace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.6.box.262.2428.1277.42.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.6.0"
    }
  }), _vm._v("All of my life I have heard of a place that sounded like it would"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.194.358.1344.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("\nbe spelled phonetically, Ponte d'Alpi. Imagine my surprise to find Ponte d'Alpi on a detailed map; a small town, Ponte d'Alpi is just north of Belluno, the capitol of Venice. It is not on the usual maps circulated in Italy for it is only a small community. The villages of Erto and Casso are a few kilometers from Ponte d'Alpi; this could be a clue to the origin of the family.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.191.358.1347.2114.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.194.686.1343.362.q.60"
    }
  }, [_vm._v("It is a known fact that Lorenzo was a marvelous sailor. He was able to handle sail boats so adroitly, to maneuver them in so skilled a manner that he soon became the envy and amazement of other boatmen. Possibly he was born at Ponte d'Alpi and as a child moved with his family to the city of Venice where he learned the intricacies of sailing. The Venetians of his youth were among the greatest sailors in the world.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.194.1070.1342.313.q.70"
    }
  }, [_vm._v("The Cassos might have had their origin in the Venetian locale and then migrated to any of the many seaports along the Italian penisula. If this is the case, then Lorenzo Casso could have been born in some other part of the country and migrated to America from there. However, one firm fact emerges from all the conjecture—the name Casso belongs to Venetia Province.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.191.1395.1345.802.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.3.0"
    }
  }), _vm._v("Among the many boatmen who worked for Lorenzo in Donaldsonville was Vincenzo Francisco Savario. After a terrible storm, which took a horrendous toll of men and boats, he seems to have been the only Italian who survived and remained in Donaldsonville. Is it possible that he was a relative of Lorenzo? Did he lose some of his kinsmen in the tragedy and decide to stay on in the place where they had settled? Savario came from Gaeta, a port on the Gulf of Gaeta, southeast of Rome and northwest of Naples, in the province of Caserta in Compania. Perhaps he was a relative of Lorenzo, or perhaps he naturally gravitated toward Lorenzo who, being the earliest Italian in Donaldsonville, represented the culture and language of home and family to Savario. He worked for the sons of Lorenzo and Mathilde after their death and the sons continued to care for him. If Savario was a relative, it could well have been that Gaeta was the birthplace of Lorenzo or his port of embarkation to the United States.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.192.2210.1344.262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.4.0"
    }
  }), _vm._v("What is my opinion? By reasoning and experience—and having been fooled too often chasing unsubstantiated rumors—I rely upon evidence alone. When all evidence is considered, I conclude that the only place I have been able to find the name of Casso is in the province of Venice, and therefore there seems more proof of origin in this"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.0.box.192.349.1345.87.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _vm._v("\nlocale than anywhere else. I certainly feel safe to say that the Cassos are Venetians.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.192.349.1346.484.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.192.458.1346.375.q.60"
    }
  }, [_vm._v("The several theories concerning the origin of the Casso family related here are the result of much study, correspondence, and search. It is intended not only as a matter of personal record but one to be passed to later descendants of Lorenzo and Mathilde Casso who might want to further pursue this elusive but interesting project. Time may prove my assumptions correct; if not, it will reveal the correct origin of the Casso family in Europe.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b65cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0012.vue
// module id = 66
// module chunks = 0